import { render, staticRenderFns } from "./HomeContest.vue?vue&type=template&id=374dcd74"
import script from "./HomeContest.vue?vue&type=script&lang=ts"
export * from "./HomeContest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports